import { useMemo, useState } from 'react';
import SectionHeading from './SectionHeading';
import { newsList, newsTags } from '@/mocks/mikami/news';

export default function NewsSection() {
  const [tag, setTag] = useState('all');
  const [keyword, setKeyword] = useState('');

  const list = useMemo(() => {
    const kw = keyword.trim().toLowerCase();
    return newsList.filter((item) => {
      const matchTag = tag === 'all' || item.tag === tag;
      const matchKeyword =
        kw === '' ||
        item.title.toLowerCase().includes(kw) ||
        item.summary.toLowerCase().includes(kw) ||
        item.tagLabel.toLowerCase().includes(kw);
      return matchTag && matchKeyword;
    });
  }, [tag, keyword]);

  return (
    <section id="news" className="anchor-offset bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="资讯消息"
          title="消息汇总与本页筛选"
          description="消息区汇总各类更新，支持按标签切换与关键词搜索。筛选仅作用于本页已列出的条目，方便在现有内容中快速定位需要的方向。"
        />

        <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-wrap gap-2 rounded-full border border-background-200 bg-background-50 px-2 py-2">
            {newsTags.map((item) => {
              const isActive = item.id === tag;
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setTag(item.id)}
                  aria-pressed={isActive}
                  className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-label transition-colors ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
                  }`}
                >
                  {item.label}
                </button>
              );
            })}
          </div>

          <div className="relative w-full lg:w-72">
            <span className="pointer-events-none absolute left-3 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索消息关键词"
              aria-label="搜索消息关键词"
              className="w-full rounded-md border border-background-300 bg-background-50 py-2.5 pl-10 pr-3 text-sm text-foreground-900 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200"
            />
          </div>
        </div>

        {list.length > 0 ? (
          <ul className="space-y-3">
            {list.map((item) => (
              <li
                key={item.id}
                className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:flex-row md:items-start md:gap-5 md:p-5"
              >
                <div className="flex shrink-0 items-center gap-2 md:w-40 md:flex-col md:items-start md:gap-1.5">
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-label text-accent-800">
                    {item.tagLabel}
                  </span>
                  <span className="text-xs text-foreground-500">{item.period}</span>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 px-4 py-12 text-center">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-background-200 text-foreground-600">
              <i className="ri-search-eye-line text-xl"></i>
            </span>
            <p className="mt-3 text-sm text-foreground-600">没有匹配的条目，试试更换标签或调整关键词。</p>
          </div>
        )}
      </div>
    </section>
  );
}